import React from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import classNames from 'classnames';

import { Card, ICardProps } from '../Card';
import { ScrollArea } from '../ScrollArea';

import styles from './Modal.module.scss';

export interface IModalProps extends RadixDialog.DialogProps, Pick<ICardProps, 'header' | 'footer' | 'className'> {
    onClose?: () => void;
}

export const Modal: React.FC<IModalProps> = ({ children, onClose, header, footer, className, ...props }) => {
    return (
        <RadixDialog.Root {...props}>
            <RadixDialog.Portal>
                <RadixDialog.Overlay className={styles.dialogOverlay}>
                    <ScrollArea className={styles.scrollArea}>
                        <div className={styles.spacer} />
                        <RadixDialog.Content
                            className={classNames(styles.dialogContent, className)}
                            onInteractOutside={onClose}
                            onEscapeKeyDown={onClose}
                            asChild
                        >
                            <Card {...{ header, footer }}>{children}</Card>
                        </RadixDialog.Content>
                        <div className={styles.spacer} />
                    </ScrollArea>
                </RadixDialog.Overlay>
            </RadixDialog.Portal>
        </RadixDialog.Root>
    );
};
